/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import { API_URL } from"../network"
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts,updateCategory,setQuote,initQuote,setLogo, setTotalPrice, setTotalAcceptedPrice, setGst, setMarginValue, setMarginPercent} from '../actions/quote'
import Category from "./Category.js"
import {supplier_arry} from "../config"
import { toast } from 'react-toastify';
import { UncontrolledTooltip, UncontrolledPopover, PopoverBody } from 'reactstrap';

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
import Product from "./IndexSections/Product.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";






// fake data generator
const getItems = (count, offset = 0) =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k + offset}-${new Date().getTime()}`,
    content: `item ${k + offset}`
  }));

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};
const grid = 8;

const getItemStyle = (isDragging, draggableStyle, index) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 0 0`,

  // change background colour if dragging
  background: isDragging ? "lightgreen" : (index%2==0?"white":"#EDECEF"),
  display:'flex',
  width:'100%',
  // styles we need to apply on draggables
  ...draggableStyle
});
const getHeaderStyle = ()=>({
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 0 0`,
  background:'#091E3F',
  fontWeight:'normal',
  display:'flex',
  width:'100%',
  color:'white',
  borderTopLeftRadius: '20px',
  borderTopRightRadius: '20px'
})
const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: 0,
  width: '100%',
  borderBottom: '6px solid #091E3F',
  minHeight:'80px',
  // marginBottom:'20px'
});

function Index(props) {
  const [costTotal, setcostTotal] = useState(0);
  const [priceTotal, setpriceTotal] = useState(0);
  const [productCostSum, setproductCostSum] = useState(0);
  const [productPriceSum, setproductPriceSum] = useState(0);
  const [sumPriceFee, setSumFee] = useState(0);
  const [sumCostFee, setSumCostFee] = useState(0);
  const [priceDecorationSum, setPriceDecorationSum] = useState(0);
  const [costDecorationSum, setCostDecorationSum] = useState(0);
  const [costDiscountSum, setCostDiscountSum] = useState(0);
  const [priceDiscountSum, setPriceDiscountSum] = useState(0);
  
  
  useEffect(() => {
    const quote = props.quote;
    const categories = quote.categories;
    var elements = [];
    var position = 0;
    var costTotal = 0
    var priceTotal = 0;
    var sumPriceFee = 0;
    var sumCostFee = 0;
    var priceDecorationSum = 0;
    var costDecorationSum = 0;
    var costDiscountSum = 0;
    var priceDiscountSum = 0;


    var totalQty = 0;
    var productPriceSum = 0;
    var productCostSum = 0;
    for(var index in categories){
      const category = categories[index]
      var groups = category.items
      if(groups){
        for(var groupInd = 0; groupInd< groups.length; groupInd++){
          var items = groups[groupInd]
          if(items){
            for(var loop = 0; loop < items.length; loop++){
              var item = items[loop];
              if(item.type == "product"){
                totalQty+=(item['qty']*1)
                productPriceSum+=((item['price']*1).toFixed(2)*item['qty'])
                productCostSum+=(item['cost']*item['qty'])
              }
              else if(item.type == "decoration"){
                var qty = item['qty']?item['qty']:0;
                var price = item['price']?item['price']:0;
                var cost = item['unit_cost']?item['unit_cost']:0;
                var setup_qty = item['setup_qty']?item['setup_qty']:0;
                var setup_price = item['setup_price']?item['setup_price']:0;
                if(item['setup_code'] == 'None'){
                  setup_qty = 0
                }
                var setup_cost = item['setup_unit_cost']?item['setup_unit_cost']:0;
                var setup_color_change_qty = item['setup_color_change_qty']?item['setup_color_change_qty']:0;
                var setup_color_change_price = item['setup_color_change_price']?item['setup_color_change_price']:0;
                var setup_color_change_cost = item['setup_color_change_unit_cost']?item['setup_color_change_unit_cost']:0;
                
                var film_qty = item['film_qty']?item['film_qty']:0;
                var film_cost = item['film_unit_cost']?item['film_unit_cost']:0;
                
                var heat_qty = item['heat_qty']?item['heat_qty']:0;
                var heat_cost = item['heat_unit_cost']?item['heat_unit_cost']:0;
                // costDecorationSum+=(qty*cost + setup_qty*setup_cost + film_qty*film_cost + heat_qty*heat_cost)
                if(item['code'] == 'Digital Print' || item['code'] == 'Vinyl Print'){
                  costDecorationSum+=(qty*cost)
                }
                else{
                  costDecorationSum+=(qty*cost + setup_qty*setup_cost + (item?.code?.includes("Screen Print")?(setup_color_change_qty*setup_color_change_cost):0))
                }
                priceDecorationSum+=(qty*price+ setup_qty*setup_price + (item?.code?.includes("Screen Print")?(setup_color_change_qty*setup_color_change_price):0))

                var discounts = item['discounts'];
                if(discounts && discounts.length > 0){
                  for(var discountInd = 0; discountInd < discounts.length; discountInd++){
                    var discountItem = discounts[discountInd]
                    if(discountItem['setup_discount_enable']){
                      var setup_discount_cost = !isNaN(discountItem['setup_discount_cost'])&&discountItem['setup_discount_cost']?discountItem['setup_discount_cost']:0;
                      var setup_discount_value = !isNaN(discountItem['setup_discount_value'])&&discountItem['setup_discount_value']?discountItem['setup_discount_value']:0;
                      var setup_discount_qty = !isNaN(discountItem['setup_discount_qty'])&&discountItem['setup_discount_qty']?discountItem['setup_discount_qty']:0;
                      costDiscountSum += setup_discount_cost*setup_discount_qty 
                      priceDiscountSum += setup_discount_value*setup_discount_qty
                    }
                  }
                }

                

              }
              else if(item.type == "delivery"){
                var qty = !isNaN(item['delivery_qty'])&&item['delivery_qty']?item['delivery_qty']:0;
                var price = !isNaN(item['delivery_price'])&&item['delivery_price']?item['delivery_price']:0;
                var cost = !isNaN(item['delivery_unit_cost'])&&item['delivery_unit_cost']?item['delivery_unit_cost']:0;
                var delivery_discount = !isNaN(item['delivery_discount'])&&item['delivery_discount']?item['delivery_discount']*1:0;
                
                costTotal+= (qty*cost);
                priceTotal+= (qty*price)
                costDiscountSum +=(delivery_discount);
                priceDiscountSum +=(delivery_discount);
              }
              else if(item.type == "discount"){
                var qty = !isNaN(item['discount_qty'])&&item['discount_qty']?item['discount_qty']:0;
                var price = !isNaN(item['discount_price'])&&item['discount_price']?item['discount_price']:0;
                var cost = !isNaN(item['discount_unit_cost'])&&item['discount_unit_cost']?item['discount_unit_cost']:0;
               
                
                costDiscountSum +=(qty*cost);
                priceDiscountSum +=(qty*price);
              }
            }
          }
          var customs = groups[groupInd]['group_options']['customs'];
          if(customs){
            for(var customInd = 0; customInd<customs.length; customInd++){
              var custom = customs[customInd];
              var tasks = custom['tasks']
              if(tasks){
                for(var taskInd = 0; taskInd < tasks.length; taskInd++){
                  var task = tasks[taskInd];
                  if(task['task_checked'] || role == "admin"){
                    var task_price = task['task_price']*1;
                    var task_cost = task['task_cost']*1;
                    var task_qty = task['task_qty']*1;
                    if(isNaN(task_price)) task_price = 0;
                    if(isNaN(task_cost)) task_cost = 0;
                    if(isNaN(task_qty)) task_qty = 0;
                    priceTotal+=(task_price*task_qty)
                    costTotal+=(task_cost*task_qty)
                  }
                }
              }
            }
          }

          
          var customfees = groups[groupInd]['group_options']['customfees'];
          if(customfees){
            for(var customFeeInd = 0; customFeeInd<customfees.length; customFeeInd++){
              var customfee = customfees[customFeeInd];
                var customfee_price = customfee['customfee_price']*1;
                var customfee_qty = customfee['customfee_qty']*1;
                if(isNaN(customfee_price)) customfee_price = 0;
                if(isNaN(customfee_qty)) customfee_qty = 0;

                var customfee_cost = customfee['customfee_cost']*1;
                if(isNaN(customfee_cost)) customfee_cost = 0;

                
                sumPriceFee+= (customfee_price*customfee_qty)
                sumCostFee+= (customfee_cost*customfee_qty)
            }
          }

          var discount = groups[groupInd]['group_options']['discount'];
          if(discount){
            var discount_qty = discount['qty']?discount['qty']*1:0;
            var discount_price = discount['price']?(discount['price']*1):0;
            var discount_cost = discount['cost']?(discount['cost']*1):0;

            if(isNaN(discount_qty)) discount_qty = 0;
            if(isNaN(discount_price)) discount_price = 0;
            if(isNaN(discount_cost)) discount_cost = 0;

            costDiscountSum +=(discount_qty*discount_cost);
            priceDiscountSum +=(discount_qty*discount_price);
          }

        }
      }
      position++;
      break;
    } 
    costTotal +=(productCostSum + sumCostFee + costDecorationSum+ costDiscountSum)
    priceTotal +=(productPriceSum + sumPriceFee + priceDecorationSum+ priceDiscountSum)
    setproductCostSum(productCostSum)
    setproductPriceSum(productPriceSum)
    setSumCostFee(sumCostFee)
    setSumFee(sumPriceFee)
    setCostDecorationSum(costDecorationSum)
    setPriceDecorationSum(priceDecorationSum)
    setCostDiscountSum(costDiscountSum)
    setPriceDiscountSum(priceDiscountSum)
    setcostTotal(costTotal)
    setpriceTotal(priceTotal)
    var margin = priceTotal - costTotal
    if(props.quote.marginValue*1 != margin && !isNaN(margin)){
      props.setMarginValue(margin) 
      if(priceTotal != 0){
        props.setMarginPercent((margin)/priceTotal*100) 
      }
      else{
        props.setMarginPercent(0) 
      }
    }
    if(props.quote.totalPrice*1 != priceTotal*1 && !isNaN(priceTotal))
      props.setTotalPrice(priceTotal)
   
      
  },[props.quote]);

  const getCategorySum = ()=>{
    var sum = 0;
    const quote = props.quote;
    const categories = quote.categories;
    for(var index in categories){
      const category = categories[index]
      var removed_fee = category['removed_fee'];
      var groups = category.items
      if(groups){
        var group = groups[0];
        var group_options = group['group_options'];
        for(var loop = 0; loop< supplier_arry.length; loop++){
          var catalog = supplier_arry[loop]['key'];
          if(group_options && group_options['cat_fee_'+catalog]){
            if(!removed_fee || (removed_fee && removed_fee.length == 0) || (removed_fee && !removed_fee.includes(catalog))){
              sum+= (group_options['cat_fee_'+catalog]*1)
            }
          }
        }
      }
    }
    return sum;
  }
  const totalMargin=()=>{
   
  }
  const totalMarginPercent=()=>{
    
  }
  var role = props.role
  return (
    <>
      <div className="total-head">
        <label className="text-left" style={{marginLeft:40}}><b>Totals</b></label>
      </div>
      <div style={{padding:'0 5px', background:'white'}}>
        <div className="d-flex">
          <div className="pt-3 w-70" >
            {role == 'admin' &&
              <div>
                {/* <div className="summary-line">
                  <div style={{width:240}}></div>
                  <label className="text-right" style={{width:240}}><b>TOTAL GARMENTS&nbsp;&nbsp;{totalQty}</b></label>
                </div> */}
                <div className="summary-line">
                  <div style={{width:180}}></div>
                  <label className="text-right" style={{width:240}}><b>WHOLESALE GARMENT TOTAL</b></label>
                  <label className="text-center" style={{width:60}}><span>&nbsp;</span></label>
                  <label className="text-center" style={{width:60}}><span className="cost-field"><b>{productCostSum.toFixed(2)}</b></span>&nbsp;</label>
                  <label className="text-center" style={{width:60}}><span>&nbsp;</span></label>
                  <label className="text-center" style={{width:60}}><b>${productPriceSum.toFixed(2)}</b></label>
                </div>
              </div>
            }
            <div>
              
              <div className="summary-line">
                <div style={{width:180}}></div>
                <label className="text-right" style={{width:240}}><b>WHOLESALE SERVICE FEE</b></label>
                <label className="text-center" style={{width:60}}><span>&nbsp;</span></label>
                <label className="text-center" style={{width:60}}><span className="cost-field"><b>{role == 'admin' ?sumCostFee.toFixed(2):""}</b></span>&nbsp;</label>
                <label className="text-center" style={{width:60}}><span>&nbsp;</span></label>
                <label className="text-center" style={{width:60}}><b>${sumPriceFee.toFixed(2)}</b></label>
              </div>
              <div className="summary-line">
                <div style={{width:180}}></div>
                <label className="text-right" style={{width:240}}><b>SUBTOTAL</b></label>
                <label className="text-center" style={{width:60}}>&nbsp;</label>
                <label className="text-center" style={{width:60}}><span className="cost-field"><span>{role == 'admin' ?(productCostSum + sumCostFee).toFixed(2):""}</span></span>&nbsp;</label>
                  <label className="text-center" style={{width:60}}><span>&nbsp;</span></label>
                <label className="text-center" style={{width:60}}>${(productPriceSum + sumPriceFee).toFixed(2)}</label>
              </div>
              <div className="summary-line last-child ">
                <div style={{width:180}}></div>
                <label className="text-right" style={{width:240}}><b>DECORATION</b></label>
                <label className="text-center" style={{width:60}}>&nbsp;</label>
                <label className="text-center" style={{width:60}}><span className="cost-field"><span>{role == 'admin' ?(costDecorationSum).toFixed(2):""}</span></span>&nbsp;</label>
                  <label className="text-center" style={{width:60}}><span>&nbsp;</span></label>
                <label className="text-center" style={{width:60}}>${(priceDecorationSum).toFixed(2)}</label>
              </div>
              {(costDiscountSum != 0 || priceDiscountSum != 0) &&
              <div className="summary-line last-child ">
                <div style={{width:180}}></div>
                <label className="text-right" style={{width:240}}><b>DISCOUNT</b></label>
                <label className="text-center" style={{width:60}}>&nbsp;</label>
                <label className="text-center" style={{width:60}}><span className="cost-field"><span>{role == 'admin' ?(costDiscountSum).toFixed(2):""}</span></span>&nbsp;</label>
                  <label className="text-center" style={{width:60}}><span>&nbsp;</span></label>
                <label className="text-center" style={{width:60}}>${(priceDiscountSum).toFixed(2)}</label>
              </div>
              }
              <div className="summary-line last-child ">
                <div style={{width:180}}></div>
                <label className="text-right" style={{width:240}}><b>GST(10%)</b></label>
                <label className="text-center" style={{width:60}}>&nbsp;</label>
                <label className="text-center" style={{width:60}}><span className="cost-field"><span>{role == 'admin' ?(costTotal/10).toFixed(2):""}</span></span>&nbsp;</label>
                  <label className="text-center" style={{width:60}}><span>&nbsp;</span></label>
                <label className="text-center" style={{width:60}}>${(priceTotal/10).toFixed(2)}</label>
              </div>
            </div>
            
          </div>
          <div className="pt-3 w-30 d-flex justify-content-center align-items-center" >
            <Button
              // onClick={()=>addDecoration(0)}
              // color="primary" 
              // href={API_URL+'upload/Important - Next Steps & How To Pay.docx'} download target="_blank"
              id="to-be-advised" 
              style={{textTransform: 'unset'}}
              className="d-flex align-items-center btn-icon btn-3 rounded-5 yellow" type="button">
              <label className="deco-icon m-0 mr-1" href="#">i</label>
              <span ><b>Next Steps</b></span>
            </Button>
            
            {/* <Button
              // onClick={()=>addDecoration(0)}
              style={{textTransform: 'unset',color:'#F6CE0E'}}
              color="primary" 
              className="d-flex align-items-center btn-icon btn-3 rounded-5" type="button">
              <label className="imp-icon m-0 mr-1" href="#" id="how-to-pay" >i</label>
              <span><b>Important !<br/>How to pay</b></span>
            </Button> */}
          </div>
          <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="to-be-advised" trigger="hover focus"> 
            <ul>
            <li>Upon quote approval, we will submit an invoice via Xero with detailed payment instructions.</li>
            <li>Payment terms will be outlined on your invoice accordingly.</li>
            <li>Please note: Payment may be required prior to production.</li>
            <li>Kindly provide remittance advice once payment has been made.</li>
            </ul>              
          </UncontrolledTooltip>
          {/* <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="how-to-pay" trigger="hover focus"> 
            When creating your job, we will identify any specific tasks required to complete your order.
            Tasks may be added here,
          </UncontrolledTooltip> */}
        </div>
        {/* {role == 'admin' &&
        <div>
          <div className="summary-line">
            <div style={{width:240}}></div>
            <label className="text-right" style={{width:240}}><b>GROSS PROFIT MARGIN</b></label>
            <label className="text-center" style={{width:60}}><span>&nbsp;</span></label>
            <label className="text-center" style={{width:60}}><span className="cost-field">&nbsp;</span>&nbsp;</label>
            <label className="text-center" style={{width:60}}>{marginValue.toFixed(2)}</label>
          </div>
          <div className="summary-line">
            <div style={{width:240}}></div>
            <label className="text-right" style={{width:240}}><b>GROSS PROFIT %</b></label>
            <label className="text-center" style={{width:60}}><span>&nbsp;</span></label>
            <label className="text-center" style={{width:60}}><span className="cost-field">&nbsp;</span>&nbsp;</label>
            <label className="text-center" style={{width:60}}>{marginPercent.toFixed(2)}</label>
          </div>
        </div>
        } */}
      </div>
      <div className="total-footer summary-line " style={{background:'rgb(9, 30, 63)', color:'#f6ce0e'}}>
        <div style={{width:180}}></div>
        <label className="text-right" style={{width:240}}><b>TOTAL</b></label>
        <label className="text-center" style={{width:60}}><span>&nbsp;</span></label>
        <label className="text-center cost-field" style={{width:60}}><span>{role == 'admin' ?"$"+(costTotal+costTotal/10).toFixed(2):""}</span></label>
        <label className="text-center" style={{width:45}}><span>&nbsp;</span></label>
        <label className="text-center pt-2 pb-2" style={{border: '2px solid rgb(246, 206, 14)', width:90}} >${(priceTotal+priceTotal/10).toFixed(2)}</label>
        {/* <label className="help-icon" style={{color:'#091e3f', margin: '0 0 0 14px'}} href="#" id="order-summit-guide-tooltip" >i</label> */}
      </div>
      
      {/* <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="order-summit-guide-tooltip" trigger="hover focus"> 
        Before you submit your quote, you must accept the following terms:
        <br/><br/>
        Upon quote approval, we will send you an invoice with payment instructions. 
        <br/><br/>
        Payment is required before production unless you are a pre-approved account customer.
        <br/><br/>
        Any changes to your order after it has been approved may incur an additional administration fee of $139+gst.
        <br/><br/>
        Please carefully review your quote before approving it.
        <br/><br/>
        We try our best to ensure that stock levels are accurate at the time of quote submission and approval, but they can change quickly. 
        <br/>
        We encourage you to approve your quote promptly to avoid potential stock availability issues.
        <br/><br/>
        Delays in quote approval and visual approval, may result in stock levels becoming unavailable, leading to potential production delays. 
        <br/>
        We strongly recommend that you prioritize the approval of your quote and subsequent visual concept.
        <br/><br/>
        Thank you
      </UncontrolledTooltip> */}
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    setTotalPrice: value=>dispatch(setTotalPrice(value)),
    setTotalAcceptedPrice: value=>dispatch(setTotalAcceptedPrice(value)),
    setGst: value=>dispatch(setGst(value)),
    updateCategory: cat=>dispatch(updateCategory(cat)),
    setQuote: quote=>dispatch(setQuote(quote)),
    initQuote:()=>dispatch(initQuote()),
    setLogo:logo=>dispatch(setLogo(logo)),
    setMarginValue: value=>dispatch(setMarginValue(value)),
    setMarginPercent: value=>dispatch(setMarginPercent(value)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
